import React, { createContext, useContext, useState } from "react"
import modelData from "../ModelData.json"
const PartsContext = createContext()
export const PartsProvider = ({ children }) => {
  const [visible, setVisible] = useState(true)
  const [models, setModels] = useState(modelData)
  const [modelComponents, setModelComponents] = useState(
    Object.entries(models).reduce((acc, [key, value]) => {
      if (value.parts && value.parts.length > 0) {
        acc[key] = {
          ...value,
          parts: value.parts[0],
        }
      } else {
        acc[key] = value
      }
      return acc
    }, {})
  )
  const [selectedParts, setSelectedParts] = useState()
  const [selectedCategory, setSelectedCategory] = useState()
  const value = {
    models,
    modelComponents,
    setModelComponents,
    visible,
    setVisible,
  }
  return <PartsContext.Provider value={value}>{children}</PartsContext.Provider>
}

export const useParts = () => {
  const context = useContext(PartsContext)
  if (!context) {
    throw new Error("useParts must be used within a PartsProvider")
  }
  return context
}
